const OrderDirectionsEnum=
{
    Asc:'Asc',
    Desc:'Desc',
};

export default OrderDirectionsEnum;